import React__default from 'react';
import { Card, Price, AccordionItem, MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { Discount } from '../../components/Discount/Discount.js';
import { PrescriptionSection } from '../../components/PrescriptionSection/PrescriptionSection.js';
import { CardGlassesConfiguration } from '../../components/CardGlassesConfiguration/CardGlassesConfiguration.js';

const LineItemCard = ({ children , billingFrequency , bundleChildLineItems , bundleConfiguration , configurationType , currency , discountPrice , imagePath , labels , price , quantity , subtitle , title , compactCard  })=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    let priceDetail = null;
    const { getLabel  } = useIntl();
    if (billingFrequency) {
        priceDetail = `/ ${billingFrequency}`;
    } else if (discountPrice) {
        priceDetail = /*#__PURE__*/ React__default.createElement(Price, {
            type: "strikethrough",
            value: price,
            currency: currency
        });
    }
    const discountLabel = {
        discount: getLabel('cart.item.discount')
    };
    return /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card, {
        className: "line-item-card",
        layout: isPhone || compactCard ? 'vertical' : 'horizontal',
        key: title
    }, /*#__PURE__*/ React__default.createElement(Card.Image, {
        alt: "",
        backgroundColor: "var(--color--shade-lightest)",
        className: "line-item-card__image",
        src: imagePath
    }), /*#__PURE__*/ React__default.createElement(Card.Content, null, /*#__PURE__*/ React__default.createElement(Card.Section, {
        className: "line-item-card__details"
    }, /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.Section, null, title ? /*#__PURE__*/ React__default.createElement(Card.Heading, {
        variant: "subheading1"
    }, title) : null), /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        flex: true,
        className: "line-item-card__subtitle"
    }, subtitle ? /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, subtitle) : null), /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "s"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption"
    }, quantity))), /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__price"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption"
    }, /*#__PURE__*/ React__default.createElement(Price, {
        value: discountPrice ? discountPrice : price,
        currency: currency
    }))), /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, priceDetail), /*#__PURE__*/ React__default.createElement(Card.Text, null, discountPrice ? /*#__PURE__*/ React__default.createElement(Discount, {
        absoluteValue: price - discountPrice,
        currency: currency,
        labels: discountLabel
    }) : null))), /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(PrescriptionSection, {
        children: children,
        labels: labels
    }), (bundleChildLineItems === null || bundleChildLineItems === void 0 ? void 0 : bundleChildLineItems.length) && configurationType === 'glasses' ? /*#__PURE__*/ React__default.createElement(AccordionItem, {
        variant: "narrow",
        label: labels.configuration,
        id: labels.configuration
    }, /*#__PURE__*/ React__default.createElement(CardGlassesConfiguration, {
        bundleConfiguration: bundleConfiguration,
        bundleChildLineItems: bundleChildLineItems
    })) : null))));
};
LineItemCard.PrescriptionSection = PrescriptionSection;
var LineItemCard$1 = LineItemCard;

export { LineItemCard$1 as default };
//# sourceMappingURL=LineItemCard.js.map
